export default "__VITE_ASSET__DLy9XzB5__"